
<template>
  <router-view />
</template>

<script>
export default {
  name: "app-event"
};
</script>

<style lang="scss" scoped></style>
